module.exports = __webpack_public_path__ + "img/1.faf31d1a.jpg";